import React from 'react';
import { IProFormaGeneralInfo, IUnitTypeOption } from 'views/ProFormaTable/types';
import { NSButton, NSCard } from 'bricks';
import ReadOnlyWrapper from 'components/ReadOnlyWrapper/ReadOnlyWrapper';
import { UsesTableProvider } from '../DevelopmentUsesTable/context/UsesTableProvider';
import DevelopmentUsesTable from '../DevelopmentUsesTable/DevelopmentUsesTable';

interface IPreviewImportSectionProps {
    title: string;
    subtitle: string | React.ReactNode;
    onCancel: () => void;
    onImport: () => void;
    isLoading?: boolean;
    navigateToSection: (sideNavName: string, tabName?: string) => void;
    initialExpandedState?: { highLevels: number[]; subcategories: number[] };
    previewData: any;
    unitTypeOptions: IUnitTypeOption[];
    setUnitType: React.Dispatch<React.SetStateAction<IUnitTypeOption | null>>;
    proForma: IProFormaGeneralInfo;
}

const PreviewImportSection = ({
    title,
    subtitle,
    onCancel,
    onImport,
    isLoading = false,
    navigateToSection,
    initialExpandedState,
    previewData,
    unitTypeOptions,
    setUnitType,
    proForma,
}: IPreviewImportSectionProps) => (
    <div>
        <NSCard className="NSCard--level-4 mb-3">
            <div className="d-flex justify-content-between p-2">
                <div>
                    <h4 className="my-0 text-white">{title}</h4>
                    <h5 className="mb-0 mt-1 text-muted">{subtitle}</h5>
                </div>
                <div className="d-flex align-items-center">
                    <NSButton
                        text="Cancel"
                        color="secondary"
                        callback={onCancel}
                        className="mr-2"
                    />
                    <NSButton
                        text="Import"
                        color="primary"
                        isLoading={isLoading}
                        callback={onImport}
                    />
                </div>
            </div>
        </NSCard>
        <ReadOnlyWrapper isReadOnly>
            <UsesTableProvider
                isProFormaReadOnly
                navigateToSection={navigateToSection}
                initialExpandedState={initialExpandedState}
            >
                <DevelopmentUsesTable
                    uses={previewData}
                    unitType={unitTypeOptions[0]}
                    setUnitType={setUnitType}
                    unitTypeOptions={unitTypeOptions}
                    proForma={proForma}
                    isPreview
                />
            </UsesTableProvider>
        </ReadOnlyWrapper>
    </div>
);

export default PreviewImportSection;
